"use client";
import PropTypes from "prop-types";
import { MONTH_NAMES, SELECT_MONTH, SELECT_YEAR } from "../../../constants/common/common";
import CustomImage from "../../../components/atoms/customImage";
import { useEffect, useRef, useState } from "react";
import Drawer from "../../../components/molecules/drawer";
import Typography from "../../../components/atoms/typography";
import { getLastNYears } from "../../../utils/common/deliveryDate";
/** */
const TestimonialsHeader = ({ handleMonthYear, year, month, isMobile, isFooter = false }) => {
  const months = MONTH_NAMES;
  const thisYear = new Date().getFullYear();
  const thisMonth = new Date().getMonth();

  const years = getLastNYears(thisYear, 6);

  const [isShowYear, setIsShowYear] = useState(false);
  const [isShowMonth, setIsShowMonth] = useState(false);
  const [selectedYear, setSelectedYear] = useState(year || thisYear);
  const [selectedMonth, setSelectedMonth] = useState(month || months[thisMonth]);

  const yearDropdownRef = useRef(null);
  const monthDropdownRef = useRef(null);

  const allMonths = selectedYear == thisYear ? months.slice(0, thisMonth + 1) : months;
  const capitalizedMonth = month ? month.charAt(0).toUpperCase() + month?.slice(1) : months[thisMonth];
  const selectedMonthIndex = months.indexOf(capitalizedMonth);

  /** */
  const handleClickOutside = (event) => {
    if (
      !isMobile &&
      yearDropdownRef.current &&
      !yearDropdownRef.current.contains(event.target) &&
      monthDropdownRef.current &&
      !monthDropdownRef.current.contains(event.target)
    ) {
      setIsShowYear(false);
      setIsShowMonth(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** */
  const showYears = () => {
    setIsShowYear((prevState) => !prevState);
    setIsShowMonth(false);
  };

  /** */
  const showMonths = () => {
    setIsShowYear(false);
    setIsShowMonth((prevState) => !prevState);
  };

  /** */
  const handleChangeYear = (value) => {
    setSelectedYear(value);
    handleMonthYear(value, selectedMonth);
    setIsShowYear(false);
  };
  /** */
  const handleChangeMonth = (value) => {
    setSelectedMonth(value);
    handleMonthYear(selectedYear, value);
    setIsShowMonth(false);
  };

  useEffect(() => {
    if (year === String(thisYear) && selectedMonthIndex > thisMonth) {
      handleChangeMonth(months[thisMonth]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** */
  const RenderYears = () => {
    return (
      <ul
        className={`${isMobile ? "relative" : "absolute rounded-4 border border-greySoft shadow-md"} ${isFooter ? "bottom-42 mb-4" : "mt-4"}  z-1 mt-4 w-full  bg-white-900`}
      >
        {years.map((item) => {
          return (
            <li
              key={item.year}
              className={`flex cursor-pointer items-center px-16 py-12 duration-300 ease-in-out hover:bg-grey-100 md:px-12 md:py-8 ${isMobile ? "text-14 font-400" : "text-16 font-400"} ${Number(selectedYear) === item.year ? "pointer-events-none font-600 text-fnp-500" : "font-400 text-fnp-500"}`}
              // eslint-disable-next-line react/jsx-handler-names
              onClick={() => handleChangeYear(item.year)}
            >
              {isMobile && (
                <span
                  className={`relative mr-10 inline-flex h-[20px] w-[20px] rounded-full border  ${Number(selectedYear) === item.year ? ":after:content-[''] border-oliveGreen after:visible after:absolute after:left-[50%] after:top-[50%] after:h-[80%] after:w-[80%] after:-translate-x-2/4 after:-translate-y-2/4 after:rounded-full after:bg-fnp-300 after:content-['']" : "border-grey"}`}
                />
              )}{" "}
              {item.year}
            </li>
          );
        })}
      </ul>
    );
  };

  /** */
  const RenderMonths = () => {
    return (
      <ul
        className={`${isMobile ? "relative" : "absolute rounded-4 border border-greySoft shadow-md"} ${isFooter ? "bottom-42 mb-4" : "mt-4"} z-1  w-full  bg-white-900`}
      >
        {allMonths.map((item) => {
          return (
            <li
              key={item}
              className={`flex cursor-pointer items-center px-16 py-12 duration-300 ease-in-out hover:bg-grey-100 md:px-12 md:py-8  ${isMobile ? "text-14" : "text-16"}  ${item === month?.charAt(0).toUpperCase() + month?.slice(1) ? "pointer-events-none font-600 text-fnp-500" : "font-400 text-fnp-500"}`}
              // eslint-disable-next-line react/jsx-handler-names
              onClick={() => handleChangeMonth(item)}
            >
              {isMobile && (
                <span
                  className={`relative mr-10 inline-flex h-[20px] w-[20px] rounded-full border  ${item === month?.charAt(0).toUpperCase() + month?.slice(1) ? ":after:content-[''] border-oliveGreen after:visible after:absolute after:left-[50%] after:top-[50%] after:h-[80%] after:w-[80%] after:-translate-x-2/4 after:-translate-y-2/4 after:rounded-full after:bg-fnp-300 after:content-['']" : "border-grey"}`}
                />
              )}
              {item}
            </li>
          );
        })}
      </ul>
    );
  };

  /** */
  const onDrawerClose = () => {
    setIsShowMonth(false);
    setIsShowYear(false);
  };

  return (
    <>
      <div className="mt-20 flex flex-col items-center gap-16 md:mt-0 md:flex-row">
        <div className="flex w-full items-center gap-16">
          <div className="relative w-1/2  md:w-[150px]" ref={yearDropdownRef}>
            <div
              // eslint-disable-next-line react/jsx-handler-names
              onClick={showYears}
              className="flex w-full cursor-pointer justify-between rounded-4 border border-greySoft bg-white-900 px-12 py-8 capitalize"
            >
              <span>{selectedYear}</span>
              <CustomImage src="/icons/filter-chevron.svg" alt="" width={20} height={20} />
            </div>
            {isShowYear && !isMobile && RenderYears()}
          </div>
          <div className="relative w-1/2  md:w-[150px]" ref={monthDropdownRef}>
            <div
              // eslint-disable-next-line react/jsx-handler-names
              onClick={showMonths}
              className="flex w-full cursor-pointer justify-between rounded-4 border border-greySoft bg-white-900 px-12 py-8 capitalize"
            >
              <span>{selectedMonth}</span>
              <CustomImage src="/icons/filter-chevron.svg" alt="" width={20} height={20} />
            </div>
            {isShowMonth && !isMobile && RenderMonths()}
          </div>
        </div>
      </div>

      <Drawer position="bottom" isOpen={(isShowYear || isShowMonth) && isMobile} onDrawerClose={onDrawerClose}>
        <Typography
          Tag={"h4"}
          variant="h2"
          classes="text-16 text-fnp-500 font-600 border-b border-thinLightGrey pb-16 px-16"
        >
          {isShowYear ? SELECT_YEAR : SELECT_MONTH}
        </Typography>
        {isShowYear && isMobile && RenderYears()}
        {isShowMonth && isMobile && RenderMonths()}
      </Drawer>
    </>
  );
};
TestimonialsHeader.propTypes = {
  handleMonthYear: PropTypes.func.isRequired,
  year: PropTypes.string,
  month: PropTypes.string,
  isMobile: PropTypes.bool.isRequired,
  isFooter: PropTypes.bool,
};
export default TestimonialsHeader;
